import { useEffect } from "react";

/**
 * Injects a <script type="application/ld+json"> tag into <head>.
 * Pass null/undefined to skip (e.g. while data is loading).
 * Accepts a single schema object or an array of schema objects.
 */
export default function useJsonLd(schema) {
  useEffect(() => {
    if (!schema) return;
    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      if (document.head.contains(script)) document.head.removeChild(script);
    };
  // JSON.stringify is intentional — re-runs only when data content changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(schema)]);
}
